import React, { useCallback } from 'react';
import { Col, Form, Modal, Row, Select } from 'antd';
import { EditDocumentIcon } from '../../../resource/icons';
import { useDispatch } from 'react-redux';
import actions from '../store/actions/edit-document.actions';

export const EditVisibilityModal = ({
  onCancel,
  visible,
  fprops,
  getFieldDecorator,
  listDocumentVisibility,
  validateFields,
  prepareDataAndResetFields,
}) => {
  const dispatch = useDispatch();

  const onOk = useCallback(() => {
    validateFields((err, values) => {
      if (err) return;
      const v = prepareDataAndResetFields(values);
      dispatch(actions.updateVisibility(v.id, v.documentVisibility));
      dispatch(actions.closeModal());
    });
  }, [dispatch, prepareDataAndResetFields, validateFields]);

  return (
    <Modal
      style={{ minWidth: 350 }}
      width={350}
      visible={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EditDocumentIcon
            style={{
              height: 40,
              verticalAlign: 'middle',
              marginRight: 10,
            }}
          />
          <div>Видимость документа</div>
        </div>
      }
      okText="Изменить"
      onCancel={onCancel}
      onOk={onOk}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={24}>
            <Form.Item label="Видимость документа">
              {getFieldDecorator('documentVisibility', {
                initialValue: fprops.documentVisibility,
                rules: [
                  {
                    required: true,
                    message: 'Пожалуйста, укажите видимость документа',
                  },
                ],
              })(
                <Select
                  placeholder="Видимость документа"
                  notFoundContent="нет данных"
                >
                  {listDocumentVisibility.map((visibilityOption) => (
                    <Select.Option
                      key={visibilityOption.id}
                      value={visibilityOption.id}
                    >
                      {visibilityOption.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
